import script from "./TressProductContentTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressProductContentTile.vue?vue&type=script&lang=ts&setup=true"

import "./TressProductContentTile.vue?vue&type=style&index=0&id=6dd1149f&lang=scss"

const __exports__ = script;

export default __exports__